import Vue from "vue";

Vue.directive("open-filter",
    {
        bind(el)
        {
            el.onclick = () =>
            {
                document.getElementsByClassName("mobile-filter")[0].classList.add("open");
                document.getElementsByTagName("body")[0].classList.add("noscroll");
            };
        }
    });
